import React from 'react'

import { CategoriesFooter } from './CategoryFooter'

const NavigationPropertyFooter = props => {
  return <CategoriesFooter {...props} />
}

export default NavigationPropertyFooter
